import React from 'react';

import cn from '~/utils/cn';

interface ClaimInfoItem {
  label: string;
  value?: string;
}

interface ClaimInfoPanelProps {
  isPanelExpanded: boolean;
  claimInfo?: Record<string, ClaimInfoItem>;
}

const InfoField: React.FC<{
  label: string;
  value?: string;
  isLastItem?: boolean;
}> = ({ label, value, isLastItem = false }) => (
  <div className={`mb-4 flex flex-col gap-8 text-sm font-semibold text-slate-800 ${isLastItem ? '' : 'mr-4'}`}>
    <span className="text-grey-500 font-medium">{label}</span>
    <span className="min-h-6 text-slate-900">{value || '---'}</span>
  </div>
);

const ClaimInfoPanel: React.FC<ClaimInfoPanelProps> = ({ isPanelExpanded, claimInfo = {} }) => {
  return (
    <div
      className={cn(
        'z-10 overflow-hidden bg-white shadow-sm transition-all duration-100 ease-in-out',
        isPanelExpanded ? 'max-h-full opacity-100' : 'max-h-0 opacity-0'
      )}
    >
      <div className="px-20 pt-40 pb-8">
        <div className="flex flex-wrap justify-start gap-40 px-20 py-2">
          {Object.entries(claimInfo).map(([key, item], index, array) => (
            <InfoField key={key} label={item.label} value={item.value} isLastItem={index === array.length - 1} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClaimInfoPanel;
